import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/sessions/backgrounds/viewpoints-pathways-background.png'
import _imports_1 from '../../assets/sessions/roots-black.png'
import _imports_2 from '../../assets/sessions/leader-types.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "session-background session-background-viewpoints-report" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "session background"
  })
], -1)
const _hoisted_2 = { class: "background-visuals" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Gyre Leadership Roots",
  style: {"width":"100%","margin":"0 auto"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  ref: "textWrapper",
  class: "text-wrapper"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "slide0",
  class: "slide-wrapper spacer-slide"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " This session guides you through your Viewpoints report and helps you reach some conclusions from the feedback you are about to work through. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " It will provide you with a solid foundation from which you can then select your personal goals and choose your personal development focus. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " As with your Solo report, there is a lot of richness here, so give yourself time to absorb it all. You might choose to go through it now and then revisit it again for a more detailed work through, layering on additional insights. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " We encourage you to take the perspective of being your own coach as you work through your Viewpoints report. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Short of time?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " If you are short of time and want a summary report that you can read at any time, click the following link to access your Viewpoints report: ", -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " Returning to our tree metaphor, this Viewpoints session guides you through how others view the roots and crown of your tree, helping you create a really rich 3-dimensional picture of yourself. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "This session is in 3 parts:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "first, we focus on how others see you in terms of the 9 Gyre leader types;"),
  /*#__PURE__*/_createElementVNode("li", null, " second, we guide you to explore whether your respondents all have the same view; "),
  /*#__PURE__*/_createElementVNode("li", null, " third, we focus on how others see your pattern of strengths, exploring the similarities and differences between others’ views and your own, and we highlight ‘confirming and challenging’ messages ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "h1 text-center" }, [
  /*#__PURE__*/_createTextVNode(" Part 1"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Your Leader types")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Based on ratings of your strengths from your Viewpoints respondents, Gyre has created this head summarising your personal fit with the 9 Gyre Leader types. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " This is shown in the right-hand head, with the diamonds representing each of the 9 Leader types and the numbers shown as you mouse (or hover) over each circle giving the ‘fit-to-profile’ scores - meaning how closely your pattern of strengths fit with each particular Leader type or profile. Click on each circle to remind yourself of each Leader type. ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " The left-hand head with the circles represents your Self-view (the one you explored in your Solo report). ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "The combination of these heads is unique to you.")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, " Use the following prompts to explore the similarities and differences between your Solo and your Viewpoints: ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Which Leader types are similar across both Solo and Viewpoints?", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " Look at the strong fit-to-profile scores (bigger circles and diamonds) and the less strong scores (smaller circles and diamonds). ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "And which Leader types show the greatest differences?", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "First, where your Viewpoints respondents see you as stronger.", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "And then, those where you see yourself as stronger.", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Begin to think about why there are these differences:", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "are there ’inner strengths’ that you don’t show strongly to other people?"),
  /*#__PURE__*/_createElementVNode("li", null, "are they recognising strengths in you that are hidden to you?"),
  /*#__PURE__*/_createElementVNode("li", null, " do your Viewpoints respondents only see you in particular contexts – at work, at study, in your private life? ")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " Your Viewpoints head is calculated by averaging scores across all of your respondents. But do they all have the same view of you? ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "Let’s look first at how they see your Best-fit Leader types.", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "This is how your respondents each see your 2 Best-fit Leader types.", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Click on the diamond to remind yourself which Leader type is which.", -1)
const _hoisted_34 = { class: "fit-breakdown-visual-inner background-cover" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "And this is how they each see your 2 Least-fit Leader types.", -1)
const _hoisted_36 = { class: "fit-breakdown-visual-inner background-cover" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", null, "Personal Reflections", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " While this is fresh in your mind, make some notes for yourself. Who has the most similar view of your Leader types as yourself? Why do you think this is? And who has the least similar view? Why do you think this is? ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, " If you have invited respondents from different aspects of your life (current colleagues, former colleagues, family, friends…) are there patterns across these different groups in how they see you? If so, how do you understand these patterns – why do you think different groups see you in different ways? And who do you think sees the ‘real’ you? ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, " And what about your emotional reaction to this feedback? What has surprised you? Has anything disappointed you? If you asked each of your respondents which Leader type you should develop, what do you think their response would be? ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "h1 text-center" }, [
  /*#__PURE__*/_createTextVNode(" Part 2"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Strength mapping")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "Next, we turn to the Strength mapping.", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, " Here we have Strength mapping from your respondents, again based on an average of their ratings (but with a bit of maths done to strip out any rating bias such as any respondents giving particularly high or low scores). ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, " Just as in your Solo report, they are presented from those seen to be most like you (and presented in the largest font to draw attention to your strengths), to those seen to be least like you (and hardest to read!) ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "Scroll up and down to view the whole list.", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, " Focus first on the strengths at the top of the list: those that are seen to be most you, most likely to contain your signature strengths. ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, " Take a look at the top 10 strengths. Clicking on them will give you a brief reminder of the definition. ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, " Think of this list as the picture people are carrying around in their heads about you about the strengths of your character and leadership. ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, " Take a moment to think about how these strengths weave together in your character. There’s a good chance that there are very few other people who have this distinctive pattern. ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, " In turn, they will be key to the kind of leadership contribution you most easily make. ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, "Do you value them all?", -1)
const _hoisted_52 = { class: "strengthListContainerContainer" }
const _hoisted_53 = { class: "strengthListContainer" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "moreLikeYou" }, [
  /*#__PURE__*/_createElementVNode("em", null, "More"),
  /*#__PURE__*/_createTextVNode(" characteristic & "),
  /*#__PURE__*/_createElementVNode("em", null, "easier"),
  /*#__PURE__*/_createTextVNode(" to develop"),
  /*#__PURE__*/_createElementVNode("span", { class: "moreArrow" })
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "lessLikeYou" }, [
  /*#__PURE__*/_createElementVNode("em", null, "Less"),
  /*#__PURE__*/_createTextVNode(" characteristic & "),
  /*#__PURE__*/_createElementVNode("em", null, "harder"),
  /*#__PURE__*/_createTextVNode(" to develop"),
  /*#__PURE__*/_createElementVNode("span", { class: "lessArrow" })
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", null, " Next, here are the 5 strengths that on average your respondents placed as least characteristic of you. ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, " Are there any here that surprise you? What do you feel about these being at the bottom of your list? Do they feel like gaps in your character? ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", null, " Be aware that the way the Gyre rating scale works means that everybody will have 5 ‘lowest’ and 5 ‘highest’ rated strengths. It’s not really a measure of whether you can or can’t exercise these strengths, but of how these strengths are balanced in your character. ", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h3", null, "Confirming and challenging messages", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", null, " Finally, we explore where you and your respondents have similar views in terms of your strengths, and where you have different views. ", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", null, " Clicking on a particular strength highlights them in both lists, showing how many positions higher or lower the strength is in the other list. ", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "hide600" }, "You can swipe left and right to look at both lists.", -1)
const _hoisted_63 = {
  ref: "strengthsListPairPositioner",
  style: {"margin":"0 auto"},
  class: "background-cover"
}
const _hoisted_64 = { ref: "strengthsListPairScaler" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h3", null, "Strengths where others rate you higher than you rate yourself", -1)
const _hoisted_66 = { class: "text-left viewpoints-comparison-slot background-cover" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h3", null, "Strengths where others rate you lower than you rate yourself", -1)
const _hoisted_68 = { class: "text-left viewpoints-comparison-slot background-cover" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h3", null, "Final reflections", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", null, " You have now worked your way through your Viewpoints report. While it is still fresh, make some notes for yourself on 2 themes: ", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Confirming messages"),
  /*#__PURE__*/_createTextVNode(" – what messages are in this Viewpoints report that confirm how you see yourself in your Solo report? ")
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Challenging messages"),
  /*#__PURE__*/_createTextVNode(" – what messages are in this Viewpoints report that challenge how you see yourself in your Solo report? ")
], -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", null, "That’s it for this session!", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", null, " It’s a lot to get through and we hope you’ve found it really stimulating and enlightening on your journey to self-awareness. ", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Remember you can always return to this session later on to revisit and deeper your understanding by accessing the menu on the Viewpoints tile of your "),
  /*#__PURE__*/_createElementVNode("em", null, "My Dashboard"),
  /*#__PURE__*/_createTextVNode(" page. ")
], -1)
const _hoisted_76 = ["href"]
const _hoisted_77 = { class: "cta-button-wrapper" }
const _hoisted_78 = {
  id: "headContainer",
  style: {"width":"80%","margin":"0 auto"}
}
const _hoisted_79 = {
  id: "headPair",
  style: {"display":"none","width":"80%","margin":"0 auto"},
  class: "text-center"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_81 = [
  _hoisted_80
]

import {
  ComponentPublicInstance,
  computed,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from "vue";
import { Power0, Power2, Power4, TimelineMax, TweenLite } from "gsap";
import * as ScrollMagic from "scrollmagic";
import axios from "axios";
import { BlendingDstFactor } from "three";
import imagesLoadedDirective from "../../directives/images-loaded";
import FitBreakdown from "../../components/fit-breakdowns/fit-breakdown.vue";
import StrengthsListInner from "../../components/strengths-lists/strengths-list-inner.vue";
import StrengthsListPair from "../../components/strengths-lists/strengths-list-pair.vue";
import { LeaderTypesApiModel, SessionsApiModel } from "../../api-models";
import useNotification, { CompletionNotification } from "../../composables/useNotification";
import viewpointsSessionLinkResourceIds from "../../services/cms/viewpoints-session-link-resource-ids";
import { SessionLayoutType } from "../../components/sessions/session-animation-controller";
import SessionWrapper from "../../components/sessions/session-wrapper.vue";
import ViewpointsComparisons from "../../components/viewpoints-comparisons/viewpoints-comparisons.vue";
import { csContext } from "../../services/cs-context";
import HeadPair from "../../components/head/head-pair.vue";
import TreeVisualWithRoots from "../../components/sessions/tree-visual-with-roots.vue";
import ShutterVisual from "../../components/sessions/shutter-visual.vue";
import SessionSlide from "../../components/sessions/session-slide.vue";
import HomeNavigation from "../../components/sessions/home-navigation.vue";
import TitleVisuals from "../../components/sessions/title-visuals.vue";
import ReportVisual from "../../components/sessions/report-visual.vue";
import NextStepsVisuals from "../../components/sessions/next-steps-visuals.vue";

import {
  createSessionsViewModelFromApiModel,
  SessionIds,
  SessionsViewModel,
} from "../../components/sessions/session-models";

import useSessionBase from "../../composables/useSessionBase";

const unlockOffset = 700;

// eslint-disable-next-line @typescript-eslint/no-var-requires

export default /*#__PURE__*/_defineComponent({
  __name: 'viewpoints-report-pathway',
  props: {
    soloRatings: {},
    viewpointsRatings: {},
    reportUrl: {},
    subjectName: {},
    sessionsModel: {}
  },
  setup(__props: any, { expose: __expose }) {

const { $ } = window as any;

const props = __props;

const vImagesLoaded = imagesLoadedDirective;

const titleLogoSrc = ref(require("../../assets/sessions/jyranian-facing-jyranians.png"));

const wheel = ref<SessionsViewModel | null>(null);

const { userProfile } = csContext;

const subjectName = computed(() => props.subjectName ?? "SUBJECT NAME");

function getSessionId(): string {
  return SessionIds.ViewpointsReport;
}

const instance = getCurrentInstance()?.proxy as ComponentPublicInstance;

const {
  isInline,
  hasCompletedSession,
  initializeAfterImagesLoaded,
  initialize,
  initializeAnimations,
  isLoading,
  handleCloseSession,
  handleKeyDown,
  layoutType,
  titleTimescale,
  loadAnimations,
  titleTextEase,
  titleVisualEase,
  zoomEnter,
  scene,
  element,
  zoomLeave,
  destroyed,
  getSessionVersion,
  classScene,
  animations,
} = useSessionBase(getSessionId, getCurrentInstance()?.proxy as ComponentPublicInstance);

const strengthsListPairWrapper = ref();
const belowStrengthsListPair = ref();
const homeNavigation = ref();
const titleVisuals = ref();
const reportVisual = ref();
const treeVisual = ref<InstanceType<typeof TreeVisualWithRoots> | null>(null);
const leaderTypeCirclesVisual = ref();
const shutterVisual = ref<InstanceType<typeof ShutterVisual> | null>(null);
const diamondHeadVisual = ref();
const heads = ref();
const rootsVisual = ref();
const strengthsListScaler = ref();

onMounted(() => {
  initialize(props.sessionsModel);
  initializeAnimations();

  // // Locking and unlocking the strengths list. We want this completely outside the main timeline because of bugs.
  classScene(
    strengthsListPairWrapper.value as HTMLElement,
    strengthsListPairWrapper.value as HTMLElement,
    "strengths-list-pair-wrapper-unclipped",
    1,
  );

  classScene(
    belowStrengthsListPair.value as HTMLElement,
    strengthsListPairWrapper.value as HTMLElement,
    "strengths-list-pair-wrapper-reclipped",
    0,
  );

  axios.get("/api/sessions").then((res) => {
    wheel.value = createSessionsViewModelFromApiModel(res.data);
  });

  // triggerNotification();
});

function onKeyDown(event: KeyboardEvent): void {
  handleKeyDown(event);
}

onUnmounted(() => {
  document.removeEventListener("keydown", onKeyDown);
  destroyed();
});

function closeSession(): void {
  handleCloseSession();
}

function handleSessionProgress(newSceneIndex: number): void {
  handleSessionProgress(newSceneIndex);
  if (newSceneIndex > 15 && !hasCompletedSession.value) {
    axios
      .post("/Report/MarkViewpointsReportAsViewed")
      .then(() => {
        hasCompletedSession.value = true;
      })
      .catch((e) => {
        alert("Failed to mark Viewpoints report as viewed");
      });
  }
}

function strengthsListFitScale() {
  const screenHeight = window.innerHeight;

  const controlHeight = 954;
  const shrinkFactor = isInline.value ? 0.8 : 0.9;

  const scale = Math.min((screenHeight / controlHeight) * shrinkFactor, 1);
  return scale;
}

loadAnimations.value = () => {
  const defaultTriggerPosition = isInline.value ? 1 : 0.3;
  const postDarkTriggerPosition = isInline.value ? defaultTriggerPosition : 0.5;
  const defaultEase = Power2.easeInOut;
  TweenLite.defaultEase = defaultEase;

  const timescale = 0.5;
  document.addEventListener("keydown", onKeyDown);
  // document.addEventListener("wheel", onWheel);

  const titleTriggerHookPosition = isInline.value ? 0.98 : 1;

  const titleTimeline = () => {
    const tl = new TimelineMax({ paused: true });

    (homeNavigation.value as any).colorSwitch(tl);
    (titleVisuals.value as any).rollIn(tl, false);

    tl.to(
      element("this-session-guides"),
      titleTimescale * 0.3,
      { autoAlpha: 1, ease: titleVisualEase.value },
      0,
    );

    return tl;
  };

  const titleScene = new ScrollMagic.Scene({
    triggerElement: element("this-session-guides-inner") as HTMLElement,
    triggerHook: titleTriggerHookPosition,
  });

  animations.value!.linkAnimationToScene(
    "title",
    titleTimeline,
    titleScene,
    undefined,
    element("this-session-guides") as HTMLElement,
  );

  scene("#short-of-time", (tl) => {
    (titleVisuals.value as any).leave(tl);
    (reportVisual.value as any).enter(tl);
  });

  scene("#returning-to-our-tree-metaphor", (tl) => {
    (reportVisual.value as any).leave(tl);
    treeVisual.value!.fadeIn(tl);
  });

  scene("#your-leader-types", (tl) => {
    tl.to(leaderTypeCirclesVisual.value, 1, { autoAlpha: 1 });

    shutterVisual.value!.close(tl);

    treeVisual.value!.fadeOut(tl);
  });

  scene("#this-head-is-unique-to-you", (tl) => {
    tl.to(leaderTypeCirclesVisual.value, 1, {
      scale: 0.3,
      autoAlpha: 0,
      xPercent: 18,
      yPercent: -6,
    }).to(diamondHeadVisual.value, titleTimescale, { autoAlpha: 1, ease: titleTextEase.value }, 0);
  });

  scene("#journal-1");

  scene("#part-2-how-consistent-is-the-feedback", (tl) => {
    (heads.value as InstanceType<typeof HeadPair>).hideLeftHead(tl);
    (heads.value as InstanceType<typeof HeadPair>).centerRightHead(tl);
  });

  scene("#best-fit-breakdown", (tl) => {
    tl.to(diamondHeadVisual.value, 1, { autoAlpha: 0 });
    tl.to("#best-fit-breakdown-visual", 1, { autoAlpha: 1 }, 0);
  });

  scene("#least-fit-breakdown", (tl) => {
    tl.to("#best-fit-breakdown-visual", 1, { autoAlpha: 1 }, 0);
    tl.to("#least-fit-breakdown-visual", 1, { autoAlpha: 1 }, 0);
  });

  scene("#journal-viewpoints-report-part-2", (tl) => {
    (heads.value as InstanceType<typeof HeadPair>).displayLeftHead(tl);
    (heads.value as InstanceType<typeof HeadPair>).moveRightHeadBackInPlace(tl);
    tl.to(diamondHeadVisual.value, 1, { autoAlpha: 1 });
  });

  scene("#part-3-strength-mapping", (tl) =>
    tl.to(rootsVisual.value, 0.2, { autoAlpha: 1 }).to(diamondHeadVisual.value, 0.2, {
      autoAlpha: 0,
      ease: titleTextEase.value,
    }),
  );

  scene("#strengths-list", (tl) =>
    tl
      .to(rootsVisual.value, 0.2, { autoAlpha: 0 })

      .to(
        strengthsListScaler.value,
        0,
        {
          scale: strengthsListFitScale(),
        },
        0,
      )
      .to("#valuing-your-strengths-visual", titleTimescale, {
        autoAlpha: 1,
        ease: titleTextEase.value,
      }),
  );

  const hiddenOnTopStrengths = $(
    ".mapping-strengths-md, .mapping-strengths-sm, .mapping-strengths-xs",
  ).toArray();

  const hiddenOnBottomStrengths = $(
    ".mapping-strengths-xl, .mapping-strengths-lg, .mapping-strengths-md, .mapping-strengths-sm",
  ).toArray();

  scene("#signature-strengths-your-story", (tl) =>
    tl
      .to(
        strengthsListScaler.value,
        titleTimescale,
        {
          scale: isInline ? 0.8 : 1,
          yPercent: isInline ? 19 : 30,
        },
        0,
      )
      .to(hiddenOnTopStrengths, titleTimescale, { color: "#ddd" }, 0),
  );

  scene("#valuing-your-strengths", (tl) =>
    tl.to(hiddenOnTopStrengths, titleTimescale, { color: "#000" }),
  );

  scene("#least-characteristic", (tl) =>
    tl
      .to(hiddenOnBottomStrengths, 0.1, { color: "#ddd" }, 0)
      .to(
        strengthsListScaler.value,
        titleTimescale,
        {
          scale: 1.5,
          yPercent: isInline ? 0 : 8,
        },
        0,
      )
      .to(".moreLikeYou, .lessLikeYou", 0.5, { autoAlpha: 0 }, 0),
  );

  scene("#confirming-and-challenging-messages", (tl) =>
    tl
      .to("#valuing-your-strengths-visual", titleTimescale, {
        autoAlpha: 0,
        ease: titleTextEase.value,
      })
      .to(hiddenOnBottomStrengths, 0.1, { color: null }, 0)
      .to("#confirming-and-challenging-messages-visual", titleTimescale, {
        autoAlpha: 1,
        ease: titleTextEase.value,
      })
      .to(".moreLikeYou, .lessLikeYou", 0.5, { autoAlpha: 1 }, 0),
  );

  scene("#viewpoints-comparison-stronger");

  scene("#viewpoints-comparison-weaker");
  scene("#final-reflections", (tl) => {
    tl.to(diamondHeadVisual.value, 1, { autoAlpha: 1 });
  });

  scene("#summary-report-2", (tl) => {
    tl.to(diamondHeadVisual.value, 1, { autoAlpha: 0 });
    (reportVisual.value as any).enter(tl);
  });
};

function onImagesLoaded() {
  initializeAfterImagesLoaded();
}

// This doesn't do anything.
function triggerNotification(): void {
  const { createCompletionNotification } = useNotification();

  const teamId = csContext.currentTeam?.id;

  if (!teamId) {
    return;
  }

  const notification: CompletionNotification = {
    userId: csContext.user.id,
    teamId,
    prismicDoc: null,
    linkResourceId: viewpointsSessionLinkResourceIds.viewpointsReport,
    linkResourceName: "Viewpoints report pathway",
  };

  createCompletionNotification(notification);
}

__expose({
  isLoading,
  getSessionId,
  getSessionVersion,
  classScene,
  isInline,
  zoomLeave,
  zoomEnter,
  titleTextEase,
  titleVisualEase,
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "session",
    class: _normalizeClass(["session viewpoints-report-pathway", {
      'session-inline': _unref(layoutType) === _unref(SessionLayoutType).Inline,
      'session-wide': _unref(layoutType) === _unref(SessionLayoutType).Wide,
      'loading': _unref(isLoading),
    }])
  }, [
    _hoisted_1,
    _createVNode(HomeNavigation, {
      ref_key: "homeNavigation",
      ref: homeNavigation
    }, null, 512),
    _createVNode(TitleVisuals, {
      ref_key: "titleVisuals",
      ref: titleVisuals,
      "session-title": "Your Viewpoints Report",
      "session-logo-image-src": titleLogoSrc.value
    }, null, 8, ["session-logo-image-src"]),
    _createVNode(ShutterVisual, {
      ref_key: "shutterVisual",
      ref: shutterVisual
    }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NextStepsVisuals, {
        ref: "nextStepsVisuals",
        "session-number": 4
      }, null, 512),
      _createVNode(TreeVisualWithRoots, {
        ref_key: "treeVisual",
        ref: treeVisual
      }, null, 512),
      _createElementVNode("div", {
        ref_key: "rootsVisual",
        ref: rootsVisual,
        class: "visual side-visual roots-visual"
      }, _hoisted_4, 512),
      _createVNode(ReportVisual, {
        ref_key: "reportVisual",
        ref: reportVisual,
        mode: "viewpoints",
        subjectName: subjectName.value
      }, {
        default: _withCtx(() => [
          _createVNode(HeadPair, {
            leftHeadKind: "solo",
            rightHeadKind: "viewpoints",
            headId: _unref(userProfile).user.id
          }, null, 8, ["headId"])
        ]),
        _: 1
      }, 8, ["subjectName"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(SessionSlide, {
        id: "this-session-guides",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "short-of-time",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: _ctx.reportUrl,
              class: "btn btn-lg btn-primary",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "View Summary Report", 8, _hoisted_13)
          ])
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "returning-to-our-tree-metaphor",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "your-leader-types",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "this-head-is-unique-to-you",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _hoisted_21,
          _hoisted_22
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "journal-1",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_23,
          _hoisted_24,
          _hoisted_25,
          _hoisted_26,
          _hoisted_27,
          _hoisted_28,
          _hoisted_29
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "part-2-how-consistent-is-the-feedback",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_30,
          _hoisted_31
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "best-fit-breakdown",
        "text-position": "dynamic",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_32,
          _hoisted_33
        ]),
        visual: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(FitBreakdown, { type: "bestfit" })
          ])
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "least-fit-breakdown",
        "text-position": "dynamic",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_35
        ]),
        visual: _withCtx(() => [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(FitBreakdown, { type: "leastfit" })
          ])
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "journal-viewpoints-report-part-2",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_37,
          _hoisted_38,
          _hoisted_39,
          _hoisted_40
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "part-3-strength-mapping",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_41
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "strengths-list",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_42,
          _hoisted_43,
          _hoisted_44,
          _hoisted_45
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "signature-strengths-your-story",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_46,
          _hoisted_47,
          _hoisted_48
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "valuing-your-strengths",
        class: "session-slide-no-bottom-margin",
        style: {"margin-bottom":"40px"},
        "visual-position": "dynamic",
        "text-position": "dynamic",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_49,
          _hoisted_50,
          _hoisted_51
        ]),
        visual: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "strengthsListScaler",
            ref: strengthsListScaler,
            style: {"margin":"0 auto","width":"100%"}
          }, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createVNode(StrengthsListInner, { ratings: _ctx.viewpointsRatings }, null, 8, ["ratings"]),
                _hoisted_55
              ])
            ])
          ], 512)
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "least-characteristic",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_56,
          _hoisted_57,
          _hoisted_58
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "confirming-and-challenging-messages",
        class: "session-slide-no-bottom-margin",
        "visual-position": "relative",
        "text-position": "dynamic",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_59,
          _hoisted_60,
          _hoisted_61,
          _hoisted_62
        ]),
        visual: _withCtx(() => [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", {
                class: "strengths-list-pair-wrapper",
                ref_key: "strengthsListPairWrapper",
                ref: strengthsListPairWrapper
              }, [
                _createVNode(StrengthsListPair, {
                  soloRatings: _ctx.soloRatings,
                  viewpointsRatings: _ctx.viewpointsRatings
                }, null, 8, ["soloRatings", "viewpointsRatings"])
              ], 512)
            ], 512)
          ], 512)
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createElementVNode("div", {
        ref_key: "belowStrengthsListPair",
        ref: belowStrengthsListPair
      }, null, 512),
      _createVNode(SessionSlide, {
        id: "viewpoints-comparison-stronger",
        "visual-position": "relative",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_65
        ]),
        visual: _withCtx(() => [
          _createElementVNode("div", _hoisted_66, [
            _createVNode(ViewpointsComparisons, { type: "stronger" })
          ])
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "viewpoints-comparison-weaker",
        "visual-position": "relative",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_67
        ]),
        visual: _withCtx(() => [
          _createElementVNode("div", _hoisted_68, [
            _createVNode(ViewpointsComparisons, { type: "weaker" })
          ])
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "final-reflections",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_69,
          _hoisted_70,
          _hoisted_71,
          _hoisted_72
        ]),
        _: 1
      }, 8, ["class-scene"]),
      _createVNode(SessionSlide, {
        id: "summary-report-2",
        "class-scene": _unref(classScene)
      }, {
        text: _withCtx(() => [
          _hoisted_73,
          _hoisted_74,
          _hoisted_75,
          _createElementVNode("p", null, [
            _createTextVNode(" You can also "),
            _createElementVNode("a", {
              href: _ctx.reportUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, "click here to view a summary report that you can read at any time.", 8, _hoisted_76)
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("a", {
              class: "btn btn-lg btn-primary journey-next-step",
              onClick: closeSession,
              onKeydown: _withKeys(closeSession, ["enter"]),
              "data-test": "session-close-button"
            }, "Close session", 32)
          ])
        ]),
        _: 1
      }, 8, ["class-scene"]),
      (_unref(userProfile))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "visual side-visual diamond-head-visual",
            ref_key: "diamondHeadVisual",
            ref: diamondHeadVisual,
            style: {"z-index":"8"}
          }, [
            _createElementVNode("div", _hoisted_78, [
              _createVNode(HeadPair, {
                leftHeadKind: "solo",
                rightHeadKind: "viewpoints",
                headId: _unref(userProfile).user.id,
                containerForTooltips: "#headContainer",
                ref_key: "heads",
                ref: heads
              }, null, 8, ["headId"])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createVNode(HeadPair, {
                leftHeadKind: "solo",
                rightHeadKind: "viewpoints",
                headId: _unref(userProfile).user.id,
                containerForTooltips: "#headPair"
              }, null, 8, ["headId"])
            ])
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "visual side-visual leader-type-circles-visual",
        ref_key: "leaderTypeCirclesVisual",
        ref: leaderTypeCirclesVisual
      }, _hoisted_81, 512)
    ], 512)
  ], 2)), [
    [_unref(vImagesLoaded), onImagesLoaded]
  ])
}
}

})